import axios from 'axios';

// API Base URL - uses environment variable or falls back to deployed backend
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://backend-d6mx.vercel.app";

// Create axios instance with credentials for cookie-based auth
const api = axios.create({
    baseURL: API_BASE_URL,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Response interceptor for handling auth errors
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            // Clear local storage and redirect to login
            localStorage.removeItem("isLoggedIn");
            localStorage.removeItem("adminInfo");
            if (window.location.pathname !== '/admin_login') {
                window.location.href = '/admin_login';
            }
        }
        return Promise.reject(error);
    }
);

export { api, API_BASE_URL };
export default API_BASE_URL;
